module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-22.37e9370e.svg";